import { createFileRoute } from '@tanstack/react-router';
import ClientContactsView from '../admin/client-contacts/view';
export const Route = createFileRoute('/admin/clients/$clientGuid/contacts/')({
  component: ClientContactsView,
});
